/**
 * Derives linked auth providers from a Supabase Auth user (e.g. email, google).
 * Pure — safe for tests and both client/server-shaped user objects.
 */

export interface SupabaseAuthProviderSource {
  identities?: Array<{ provider?: string | null }> | null
  app_metadata?: { provider?: string | null } | null
}

export function extractSupabaseAuthProviders(
  user: SupabaseAuthProviderSource | null | undefined,
): string[] {
  if (!user) return []

  const fromIdentities = (user.identities ?? [])
    .map((identity) => identity.provider)
    .filter((provider): provider is string => typeof provider === 'string' && provider.length > 0)

  const unique = [...new Set(fromIdentities)]
  if (unique.length > 0) {
    return unique.sort()
  }

  const metaProvider = user.app_metadata?.provider
  if (typeof metaProvider === 'string' && metaProvider.length > 0) {
    return [metaProvider]
  }

  return []
}

export function getPrimarySupabaseAuthProvider(
  user: SupabaseAuthProviderSource | null | undefined,
): string {
  const providers = extractSupabaseAuthProviders(user)
  return providers[0] ?? 'unknown'
}
